import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap';
import useManageDashboardOverview from '../../hooks/patientDashboard/usemanageDashboardData';
import moment from 'moment';

const AppointmentSidebar = () => {
const {appointments, loading, handleFetAppointments, handleCancelAppointment}= useManageDashboardOverview();
  

 useEffect(() => {
  handleFetAppointments();
}, [])
    
// console.log(appointments)
  return (
    <Col xl="3" className="d-none mt-6 app-sidebar d-xl-block">
      <div className="data-sidebar-card">
        <h5 className="data-sidebar-title">Missed Appointments</h5>
        <div className="data-sidebar-stack">
          {appointments?.filter((x) => x?.status == "missed")?.length > 0 ? (
            appointments
              ?.filter((x) => x?.status == "missed")
              ?.slice(0, 2)
              ?.map((item) => (
                <div key={item?.id} className="data-sidebar-item">
                  <span className="data-status-badge is-danger mb-2">Missed</span>
                  <div className="data-cell-title">{item?.whomToSee?.job_title}</div>
                  <div className="data-cell-meta">{moment(item?.appointment_date).format('ddd, DD, MMM, yyyy')}</div>
                  <p className="fs-xs mb-0 mt-2 text-capitalize">
                    Booked to see: Dr. {item?.whomToSee?.first_name} {item?.whomToSee?.last_name}
                  </p>
                </div>
              ))
          ) : (
            <div className='data-sidebar-item text-center text-muted'>No record</div>
          )}
        </div>

        <h5 className="data-sidebar-title mt-4">Cancelled Appointments</h5>
        <div className="data-sidebar-stack">
          {appointments?.filter((x) => x?.status == "Cancelled")?.length > 0 ? (
            appointments
              ?.filter((x) => x?.status == "Cancelled")
              ?.slice(0, 2)
              ?.map((item) => (
                <div key={item?.id} className="data-sidebar-item">
                  <span className="data-status-badge is-neutral mb-2">Cancelled</span>
                  <div className="data-cell-title">{item?.consultation_type ?? "---"}</div>
                  <div className="data-cell-meta">{moment(item?.appointment_date).format("ddd, Do, MMMM,yyyy")}</div>
                  <p className="fs-xs mb-0 mt-2 text-capitalize">
                    Booked to see: Dr. {item?.whomToSee?.first_name} {item?.whomToSee?.last_name}
                  </p>
                </div>
              ))
          ) : (
            <div className='data-sidebar-item text-center text-muted'>No record</div>
          )}
        </div>
      </div>
    </Col>
  )
}

export default AppointmentSidebar
